import {AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {ExcCoreModule, ExcTranslation} from 'exc-core-v2';
import {ExgDataTableComponent, ExgModalService, ExgTableSettingsComponent} from 'exc-controls-v2';
import {ExgFilterComponent} from '../../misc/exg-filter/exg-filter.component';
import {ExcRestService, IExcDataDistinct, IExcDataFilter, IExcDataPaging, IExcDataSort} from 'exc-rest-v2';
import {IExcMetaInfo} from 'exc-rest-v2/lib/interfaces/IExcMetaInfo';
import {EnumerationService} from '../../services/enumeration.service';
import {ApplicationService} from '../../services/application.service';
import {ExgFilterChipsComponent} from '../../misc/exg-filter-chips/exg-filter-chips.component';
import {BehaviorSubject} from 'rxjs';

@Component({
  selector: 'app-schedule-list',
  templateUrl: './schedule-list.component.html',
  styles: []
})
export class ScheduleListComponent extends ExcTranslation implements OnInit, AfterViewInit {

  /****************************/
  @ViewChild('VCscheduleTable', {read: ExgDataTableComponent}) VCmessageTable!: ExgDataTableComponent;
  @ViewChild('VCscheduleTableFilterControl', {read: ExgFilterComponent}) VCscheduleTableFilterControl!: ExgFilterComponent;
  @ViewChild('VCscheduleTableSortControl', {read: ExgFilterComponent}) VCscheduleTableSortControl!: ExgFilterComponent;
  @ViewChild('VCscheduleTableSearchControl', {read: ExgFilterComponent}) VCscheduleTableSearchControl!: ExgFilterComponent;
  @ViewChild(ExgTableSettingsComponent) VCtableDefinitionSettings!: ExgTableSettingsComponent;
  @ViewChild('VCFilterChips', { read: ExgFilterChipsComponent }) VCFilterChips!: ExgFilterChipsComponent;
  /****************************/

  init = true;
  preFilterDefinition: any[] = [];
  selectedMod: any;
  selectedType: any;
  scheduleTable = {
    selectKey: 'apiID',
    newV2Table: false,
    prefilterObject: {order: 8, caption: 'Aktive - Alle', value: 0},
    prefilter: 0,
    state: 1,
    selectedRow: undefined as any,
    searchValue: '',
    uiFilterEnumGroup: [
      {
        enmName: 'Schadenart',
        enmField: 'aue_enmIdent_SchadenArt',
        enmTable: 'AuftragE_EIS',
        enmAlt: false,
        enmAltTT: true
      },
      {
        enmName: 'VorgangStatus',
        enmField: 'vorg_enmIdent_VorgangStatus',
        enmTable: 'Vorgang',
      },
      {
        enmName: 'VorgangTyp',
        enmField: 'vorg_enmIdent_VorgangTyp',
        enmTable: 'Vorgang',
      },
      {enmName: 'AuftragTyp', enmField: 'au_enmIdent_AuftragTyp', enmTable: 'Auftrag'}
    ],
    uiFilterSearchFields: [
      {table: 'Vorgang', tableField: 'vorgNr'},
      {table: 'Vorgang', tableField: 'vorgBearbeiter'},
      {table: 'Vorgang', tableField: 'vorgFrist'},
      {table: 'All', tableField: 'vorgLCU', groupCaption: 'Vorgang'},
      {table: 'All', tableField: 'vorgLCD', groupCaption: 'Vorgang'},
      {table: 'All', tableField: 'vorgCKD', groupCaption: 'Vorgang'},
      {table: 'AuftragE_EIS', tableField: 'aueSchadenNr', groupCaption: 'Schaden'},
      {table: 'AuftragE_EIS', tableField: 'aueVersicherungsnehmer', groupCaption: 'Schaden'},
      {table: 'AuftragE_EIS', tableField: 'aueSchadenOrt', groupCaption: 'Schaden'},
      {table: 'Auftrag', tableField: 'auAuftraggeber', repColumn: 'au_oeID_Auftraggeber'},
      {table: 'Auftrag', tableField: 'auAnsprechpartner'},
      {table: 'Ablaufplan', tableField: 'apiPlanDatumSearch'},
      {table: 'Ablaufplan', tableField: 'apiSollDatumSearch'},
      {table: 'Ablaufplan', tableField: 'apiIstDatumSearch'},
    ],
    uiSortFieldGroup: [
      { fieldGroup: 'Ablaufplan', fieldTable: 'Ablaufplan', fieldName: 'apiPlanDatum' },
      { fieldGroup: 'Ablaufplan', fieldTable: 'Ablaufplan', fieldName: 'apiSollDatum' },
      { fieldGroup: 'Ablaufplan', fieldTable: 'Ablaufplan', fieldName: 'apiIstDatum' },
      { fieldGroup: 'Ablaufplan', fieldTable: 'All', fieldName: 'apiCRD' },
      { fieldGroup: 'Ablaufplan', fieldTable: 'All', fieldName: 'apiLCD' },
      {fieldGroup: 'Vorgang', fieldTable: 'All', fieldName: 'vorgLCD'},
      {fieldGroup: 'Vorgang', fieldTable: 'All', fieldName: 'vorgCRD'},
      {fieldGroup: 'Vorgang', fieldTable: 'All', fieldName: 'vorgCKD'},
      {fieldGroup: 'Vorgang', fieldTable: 'Vorgang', fieldName: 'vorgFrist'},
      {
        fieldGroup: 'Auftrag',
        fieldTable: 'AuftragE_EIS',
        fieldName: 'aueSchadenDatum',
      },
      {
        fieldGroup: 'Auftrag',
        fieldTable: 'AuftragE_EIS',
        fieldName: 'aueAuftragsdatum',
      },
      {
        fieldGroup: 'Auftrag',
        fieldTable: 'AuftragE_EIS',
        fieldName: 'aueOrtsterminPlan',
      },
      {
        fieldGroup: 'Auftrag',
        fieldTable: 'AuftragE_EIS',
        fieldName: 'aueOrtstermin',
      },
      {
        fieldGroup: 'Auftrag',
        fieldTable: 'AuftragE_EIS',
        fieldName: 'aueOrtstermin2',
      },
      {
        fieldGroup: 'Auftrag',
        fieldTable: 'AuftragE_EIS',
        fieldName: 'aueSchadenmeldungVU',
      },
      {
        fieldGroup: 'Auftrag',
        fieldTable: 'AuftragE_EIS',
        fieldName: 'aueFristverlaengerungBis',
      },
      {
        fieldGroup: 'Auftrag',
        fieldTable: 'AuftragE_EIS',
        fieldName: 'aueZwischenberichtDatum',
      },
    ],
    uiFilter: [] as any[],
    uiSort: [] as any[],
    uiSortAktiv(): any[] {
      return this.uiSort.filter((sort: any) => sort.uiValue !== 0);
    },
    uiFilterAktiv(filterType?: number): any[] {
      return this.uiFilter
        .filter((filters: any) => filters.applied)
        .filter((filters: any) => !filterType || (filterType && filterType === filters.filterType));
    },
    data: [] as any[],
    tableDefinition: [] as any[],
    distinctData: [] as any[],
    MetaInfo: {
      dataPaging: {pageNo: 0, pageSize: 24} as IExcDataPaging,
      dataSort: {} as IExcDataSort,
      dataFilter: {} as IExcDataFilter,
      dataDistinct: {} as IExcDataFilter,
    } as IExcMetaInfo,
    paging: {pagingPage: 0, pagingEndRow: 0, pagingPageSize: 25, pagingTotalPages: 0, pagingTotalRows: 0, pagingStartRow: 0},
    isLoading: true,
    ready: () => {
      if (!this.scheduleTable.data || this.scheduleTable.data.length === 0) {
        this.scheduleTable.state = 2;
        if (this.VCmessageTable) {
          this.VCmessageTable.selectedRow = -1;
        }
      } else {
        this.scheduleTable.state = 0;
        if (this.VCmessageTable) {
          this.VCmessageTable.selectedRow = 0;
        }
      }
      this.init = false;
      this.scheduleTable.isLoading = false;
      this.tableIsLoading.next(this.scheduleTable.isLoading);
    },
    selectionChanged: (index: number) => {
      this.scheduleTable.selectedRow = this.scheduleTable.data[index];
      this.tableIsLoading.next(false);
    },
    dblClick: (index: number) => {
      this.scheduleTable.selectionChanged(index);
      this.VCmessageTable.selectedRow = index;
      this.openReference();
    },
    pageChanged: (page: number) => {
      if (this.scheduleTable.MetaInfo.dataPaging !== undefined) {
        this.scheduleTable.MetaInfo.dataPaging.pageNo = page;
      }
      this.scheduleTable.loadData();
    },
    search: (value: string) => {
      this.scheduleTable.searchValue = value;
      this.scheduleTable.pageChanged(1);
    },
    loadData: () => {
      const SELF = this;
      SELF.scheduleTable.state = 1;
      SELF.scheduleTable.isLoading = true;
      this.tableIsLoading.next(SELF.scheduleTable.isLoading);
      SELF.excRest
        .sget(
          SELF.excRest.computeUrl(
            'AblaufplanR_List',
            {
            filter: this.scheduleTable.prefilter,
            fts: this.scheduleTable?.searchValue
          }),
            'MessageListState',
            {
            MetaInfo: {
              dataPaging: this.scheduleTable.MetaInfo.dataPaging,
              dataSort: this.scheduleTable.MetaInfo.dataSort,
              dataFilter: this.scheduleTable.MetaInfo.dataFilter
            }
          })
        .subscribe(
          (response) => {
            if (response.success && response.data) {
              SELF.scheduleTable.data = response.data.ScheduleItems;
              SELF.scheduleTable.paging = response.paging.ScheduleItems;
            } else {
              SELF.scheduleTable.data = [];
              SELF.scheduleTable.paging = {
                pagingPage: 0, pagingEndRow: 0, pagingPageSize: 25
                , pagingTotalPages: 0, pagingTotalRows: 0, pagingStartRow: 0
              };
            }

          }
        ).add(() => {
          SELF.scheduleTable.ready();
          this.VCFilterChips?.workspace.computeMetaInfo(this.appSvc.helperObj.clone(this.scheduleTable.MetaInfo));
        });
    },
    getDistinctData: (dataDistinct: IExcDataDistinct) => {
      this.scheduleTable.MetaInfo.dataDistinct = dataDistinct;
      this.excRest
        .sget(
          this.excRest.computeUrl('AblaufplanR_List',
            {
              filter: this.scheduleTable.prefilter,
              fts: this.scheduleTable?.searchValue
            }),
          ExcCoreModule.Guid.NewGuid(),
          {MetaInfo: this.scheduleTable.MetaInfo}
        ).subscribe((ret: any) => {
        // console.log(ret.data);
        this.scheduleTable.distinctData = ret.data;
      });
    }
  };
  tableIsLoading = new BehaviorSubject(false);

  constructor(
    private chDecRef: ChangeDetectorRef,
    public excRest: ExcRestService,
    private appSvc: ApplicationService,
    private modal: ExgModalService,
    public enumSvc: EnumerationService) {
    super();
    setInterval(() => {
      this.chDecRef.detectChanges();
    }, 15);
  }

  ngOnInit(): void {
    this.initialize();
    this.registerEvents();
    this.initEnumerations();
    this.initTableDefinition();
  }

  ngAfterViewInit(): void {
    this.changePreFilterMod(this.preFilterDefinition[0]);
  }

  initEnumerations(): void {
    this.scheduleTable.uiFilter = this.appSvc.metaInfo.dataFilter(
      this.scheduleTable.uiFilterEnumGroup,
      this.scheduleTable.uiFilterSearchFields);
    this.scheduleTable.uiSort = this.appSvc.metaInfo.dataSort(this.scheduleTable.uiSortFieldGroup);
  }

  initTableDefinition(): void {
    this.scheduleTable.tableDefinition = [
      {
        caption: this.enumSvc.getFieldCaption('Vorgang', 'vorgNr')
        , value: 'api_OidNr'
        , fixed: true, align: 0, sort: 0, ordinal: 0, visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('AuftragE_EIS', 'aueSchadenNr')
        , value: 'aueSchadenNr'
        , fixed: true, align: 0, sort: 0, ordinal: 0, visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('Auftrag', 'au_enmIdent_AuftragTyp')
        , value: 'au_enmIdent_AuftragTyp'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
        , transformValue: (value: any) => {
          return this.enumSvc.getEnumerationText('AuftragTyp', value);
        }
      },
      {
        caption: this.enumSvc.getFieldCaption('Vorgang', 'vorg_enmIdent_VorgangTyp')
        , value: 'vorg_enmIdent_VorgangTyp'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
        , transformValue: (value: any) => {
          return value ? this.enumSvc.getEnumerationText('VorgangTyp', value) : ' - ';
        }
      },
      {
        caption: this.enumSvc.getFieldCaption('Vorgang', 'vorg_oid_Bearbeiter')
        , value: 'vorgBearbeiter'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
      },
      {
        caption: this.getRessource('TableRenames.lastSV')
        , value: 'aueLetzterSachverstaendiger'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('Vorgang', 'BearbeiterCo')
        , value: 'BearbeiterCo'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('Ablaufplan', 'apiBezeichnung')
        , value: 'apiBezeichnung'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('Ablaufplan', 'apiKommentar')
        , value: 'apiKommentar'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('Ablaufplan', 'apiSollDatum')
        , value: 'apiSollDatum'
        , fixed: false
        , align: 0, sort: 0
        , type: 'date', dateFormat: this.getGlobal('DateFormat')
        , visible: true
        , transformValue: (value: any) => {
          return value;
        }
      },
      {
        caption: this.enumSvc.getFieldCaption('Ablaufplan', 'apiPlanDatum')
        , value: 'apiPlanDatum'
        , fixed: false
        , align: 0, sort: 0
        , type: 'date', dateFormat: this.getGlobal('DateFormat')
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('Ablaufplan', 'apiIstDatum')
        , value: 'apiIstDatum'
        , fixed: false
        , align: 0, sort: 0
        , type: 'date', dateFormat: this.getGlobal('DateFormat')
        , visible: true
      },
      {
        caption: this.getRessource('TableRenames.CaseStatus')
        , value: 'au_enmIdent_AuftragStatus'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
        , transformValue: (value: any) => {
          return this.enumSvc.getEnumerationText('AuftragStatus', value);
        }
      },
      {
        caption: this.getRessource('TableRenames.TaskStatus')
        , value: 'vorg_enmIdent_VorgangStatus'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
        , transformValue: (value: any) => {
          return value ? this.enumSvc.getEnumerationText('VorgangStatus', value) : ' - ';
        }
      },
      {
        caption: this.enumSvc.getFieldCaption('All', '%CKU')
        , value: 'api_OidCKU'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('All', '%CKD')
        , value: 'api_OidCKD'
        , fixed: false
        , align: 0, sort: 0
        , type: 'date', dateFormat: this.getGlobal('DateTimeFormatShort')
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('All', '%LCU')
        , value: 'apiLCU'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('All', '%LCD')
        , value: 'apiLCD'
        , fixed: false
        , align: 0, sort: 0
        , type: 'date', dateFormat: this.getGlobal('DateTimeFormatShort')
        , visible: true
      },
    ];
  }

  registerEvents(): void {
    ExcCoreModule.Services().GlobalRefresh.subscribe(() => {
      this.scheduleTable.loadData();
    });
    this.enumSvc.repositoryLoaded.subscribe(() => {
      this.initEnumerations();
      this.initTableDefinition();
    });
    this.tableIsLoading.subscribe(async (value) => {
      await this.chDecRef.reattach();
      if (!value) {
        await new Promise(f => setTimeout(f, 1000));
        this.chDecRef.detach();
      }
    });
  }

  initialize(): void {
    const SELF = this;
    SELF.preFilterDefinition = [{
      value: 'open', get caption(): string {
        return SELF.getRessource(this.value + '.caption');
      }, types: [{
        value: '0', get caption(): string {
          return SELF.getRessource('open.' + this.value);
        }
      }, {
        value: '1', get caption(): string {
          return SELF.getRessource('open.' + this.value);
        }
      }, {
        value: '2', get caption(): string {
          return SELF.getRessource('open.' + this.value);
        }
      }, {
        value: '3', get caption(): string {
          return SELF.getRessource('open.' + this.value);
        }
      }]
    }, {
      value: 'released', get caption(): string {
        return SELF.getRessource(this.value + '.caption');
      }, types: [{
        value: '10', get caption(): string {
          return SELF.getRessource('released.' + this.value);
        }
      }]
    }];
  }

  changePreFilterMod(event: any): void {
    this.selectedMod = event;
    // this.messageTable.prefilterMod = event.value;
    this.changePreFilterType(this.selectedMod.types[0]);
  }

  changePreFilterType(event: any): void {
    this.selectedType = event;
    this.scheduleTable.prefilter = event.value;
    this.VCscheduleTableFilterControl.ApplyFilter();
  }

  openReference(): void {
    if (this.scheduleTable.selectedRow.api_OidTyp === 'Auftrag') {
      /*ToDo. Implemnt jump to Case Workspace*/
    } else if (this.scheduleTable.selectedRow.api_OidTyp === 'Vorgang') {
      this.appSvc.Task.Workspace.OpenTabV2(this.scheduleTable.selectedRow.api_oid);
    }
  }

  OpenDetailHistoryModal(): void {
    if (!this.scheduleTable.isLoading
      && this.scheduleTable.selectedRow[this.scheduleTable.selectKey]) {
      this.modal
        .show('ModalDetailHistoryComponent', {ID: this.scheduleTable.selectedRow[this.scheduleTable.selectKey]})
        .subscribe(() => {});
    }
  }

  openTableSettings($event: any): void {
    if (this.scheduleTable.newV2Table) {
      this.VCtableDefinitionSettings.openFilterConfig($event);
    }
  }
}
